<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="" prop="gameId">
            <el-select v-model="queryForm.gameId" placeholder="请选择游戏"  class="mr-10">
              <el-option
                v-for="item in gameList"
                :key="item.gameId"
                :label="item.title"
                :value="item.gameId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="date"
              placeholder="选择日期"
              :clearable="false"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="头像"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <img :src="row.people.avatar" class="avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="昵称"
        prop="people.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="名次"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ $index }">
          <el-tag type="success" v-if="$index===0">第一名</el-tag>
          <el-tag type="info" v-if="$index===1">第二名</el-tag>
          <el-tag type="warning" v-if="$index===2">第三名</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="积分"
        prop="score"
        show-overflow-tooltip
      >
      <template #default="{ row }">
          {{row.score || 0}}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ row.basic.date }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleCheck(row)">积分明细</el-button>
        </template>
      </el-table-column> -->
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <score-detail ref="scoreDetail"></score-detail>
  </div>
</template>

<script>
import moment from 'moment'
import { findList,findPeopleScoreRank } from '@/api/game'
import ScoreDetail from './scoreDetail.vue'
export default {
  name: 'PeopleRank',
  components:{ScoreDetail},
  data() {
    return {
      moment,
      list: [],
      gameList: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        gameId:'',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/game/peopleRank') {
        // this.fetchData()
        this.getGameList()
      }
    },
  },
  created() {
    this.getGameList()
    // this.fetchData()
  },
  methods: {
    handleCheck(row) {
      this.$refs['scoreDetail'].show(row,this.queryForm.gameId)
    },
    //获取游戏
    async getGameList() {
      const { list } = await findList({ page: 1, size: 1000 })
      this.gameList = list
      this.queryForm.gameId = list[0]&&list[0].gameId
      this.fetchData()
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findPeopleScoreRank(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
</style>
